/**
 * 将数值转换成中文 '0:未启/1:已启'
 * 
 * @param {*} val 数值
 * @param {*} map 值对
 * @return {string} 中文值
 */
export function dict(val, map) {
    var maps = map.split("/");
    for (var i in maps) {
        var kv = maps[i].split(":");
        if (kv[0] == val) {
            return kv[1];
        }
    }
    return "其他";
}

/**
 * 将数值转换成中文 '0:未启/1:已启'
 * 
 * @param {*} val 数值
 * @param {*} map 值对
 * @return {string} 中文值
 */
 export function dictA(val, map) {
    let value = "";
    if (val && val.includes(",")) {
        value = val.split(",").map(item => pre(item, map)).join();
    } else {
        value = pre(val, map)
    }
    return value;
}

function pre(val, map) {
    var maps = map.split("/");
    for (var i in maps) {
        var kv = maps[i].split(":");
        if (kv[0] == val) {
            return kv[1];
        }
    }
    return "其他";
}